export const fmtPKR = (n) =>
  "Rs " + Number(n || 0).toLocaleString("en-PK", { maximumFractionDigits: 0 });

export const fmtDate = (iso) => {
  if (!iso) return "-";
  try {
    return new Date(iso).toLocaleString("en-GB", {
      day: "2-digit", month: "short", year: "numeric",
      hour: "2-digit", minute: "2-digit",
    });
  } catch { return iso; }
};

export const statusColor = (s) => {
  const map = {
    pending: "bg-yellow-500/15 text-yellow-400 border-yellow-500/30",
    active: "bg-blue-500/15 text-blue-400 border-blue-500/30",
    open: "bg-blue-500/15 text-blue-400 border-blue-500/30",
    upcoming: "bg-slate-500/15 text-slate-300 border-slate-500/30",
    processing: "bg-blue-500/15 text-blue-400 border-blue-500/30",
    live: "bg-orange-500/15 text-orange-400 border-orange-500/30",
    locked: "bg-purple-500/15 text-purple-400 border-purple-500/30",
    won: "bg-emerald-500/15 text-emerald-400 border-emerald-500/30",
    approved: "bg-emerald-500/15 text-emerald-400 border-emerald-500/30",
    active_ref: "bg-emerald-500/15 text-emerald-400 border-emerald-500/30",
    lost: "bg-red-500/15 text-red-400 border-red-500/30",
    draw: "bg-amber-500/15 text-amber-400 border-amber-500/30",
    postponed: "bg-amber-500/15 text-amber-400 border-amber-500/30",
    rejected: "bg-red-500/15 text-red-400 border-red-500/30",
    completed: "bg-emerald-500/15 text-emerald-400 border-emerald-500/30",
    under_review: "bg-blue-500/15 text-blue-400 border-blue-500/30",
    additional_required: "bg-yellow-500/15 text-yellow-400 border-yellow-500/30",
    open_ticket: "bg-yellow-500/15 text-yellow-400 border-yellow-500/30",
    resolved: "bg-emerald-500/15 text-emerald-400 border-emerald-500/30",
  };
  return map[s] || "bg-slate-500/15 text-slate-300 border-slate-500/30";
};
